import { createActions } from 'redux-actions';

import { ENDPOINTS_USER } from '../../config/';
import { AlphaAPIBase } from '../../reducers/DashboardReducer/Alphas/AlphasReducer.types';
import { defaultErrorMessage, globalFetch, isAction } from '../../shared/helpers/fetch-helper';
import { logErrorService } from '../../shared/services';

export const { dashboardAlphasResponse, dashboardAlphasRequest, dashboardAlphasResponseFailure } = createActions(
  {
    DASHBOARD_ALPHAS_RESPONSE: (data: AlphaAPIBase) => ({ data }),
  },
  'DASHBOARD_ALPHAS_REQUEST',
  'DASHBOARD_ALPHAS_RESPONSE_FAILURE'
);

export function getDashboardAlphas() {
  return async (dispatch: any, getState: any): Promise<object> => {
    const state = getState();
    if (state.getIn(['dashboard', 'alphas', 'isfetching']) === true) {
      return dispatch(dashboardAlphasRequest());
    }

    dispatch(dashboardAlphasRequest());

    return globalFetch(
      `${ENDPOINTS_USER.user}/self/alphas/summary`,
      {
        method: 'GET',
        credentials: 'include',
        headers: new Headers({
          'Content-Type': 'application/json',
        }),
      },
      dispatch,
      () => dispatch(dashboardAlphasResponseFailure()),
      { endpointVersion: 'version=4.0' }
    )
      .then(async (json: any): Promise<object> => {
        if (isAction(json, 'DASHBOARD_ALPHAS_RESPONSE_FAILURE')) {
          return json;
        } else {
          return dispatch(dashboardAlphasResponse(json));
        }
      })
      .catch((err: any) => {
        logErrorService(err, err);
        defaultErrorMessage(dispatch);

        return dispatch(dashboardAlphasResponseFailure());
      });
  };
}
